import { render, staticRenderFns } from "./KitMetricTable.vue?vue&type=template&id=709ec11a"
import script from "./KitMetricTable.vue?vue&type=script&lang=ts"
export * from "./KitMetricTable.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricTable.vue?vue&type=style&index=0&id=709ec11a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports